<template>
    <div>
        <div class="wrap-filter display-flex display-flex-space-between">
            <FilterElectronicLectures class="flex-left" @handleSeach="handleSeach" />
            <div class="flex-right"></div>
        </div>

        <div class="row" v-if="listDataLessonClassSchool.length > 0">
            <div class="col-md-4" v-for="(item, index) of listDataLessonClassSchool" :key="index">
                <ItemElectronicLecture :type="PLANING_LESSON_ASSIGN" :item="item" />
            </div>

        </div>
        <div class="row" v-else>
            <div class="col-md-12 empty-data">Kế hoạch bài dạy đang giao không có dữ liệu</div>
        </div>
        <div class="row pagination container m-0">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
    </div>
</template>
<script>

import FilterElectronicLectures from './FilterElectronicLectures'
import ItemElectronicLecture from './ItemElectronicLecture'
import { getListlLessonAssign } from './../../_api/LessonClassSchoolServices'

import { PLANING_LESSON_WAREHOUSE, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN, PLANING_LESSON_ASSIGN } from './../../constants/constants_enum'
export default {
    components: {
        FilterElectronicLectures,
        ItemElectronicLecture,
    },
    data() {
        return {
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN,
            ElectronicLecturesAssign: 1,
            isOpenModalCreateUpdateElectronicLectures: false,
            isOpenModalDeleteLesson: false,
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                type: PLANING_LESSON_WAREHOUSE,
                pageSize: 6,
                subjectId: 0,
                classId: 0
            },
            lessonIdCurrent: 0,
            totalRecords: 0,
            listDataLessonClassSchool: [],

        }
    },
    watch: {
        'paramQueryData.pageIndex': 'getListLessonClassSchool',
    },
    mounted() {
        this.getListLessonClassSchool()

    },
    methods: {
        handleSeach(query) {
            this.paramQueryData.keyword = query.keyword
            this.paramQueryData.subjectId = query.subjectId
            this.paramQueryData.classId = query.classId
            this.getListLessonClassSchool()
        },
        getListLessonClassSchool() {
            let self = this
            getListlLessonAssign(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataLessonClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap-filter {
    margin-top: 20px;
}

.pagination {
    margin-bottom: 20px;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.display-flex-space-between {
    justify-content: space-between;
}

.empty-data {
    margin-top: 15px;
    text-align: center;
}

.flex-left {
    flex: 2;
}

.flex-right {
    flex: 1;
}
</style>